<!-- new payment -->
<app-page-body
  [class]="'tw-pt-2'"
  *ngIf="!isVisibleInvoice && !isVisibleHelpPage && pageConfig.isVisibleForm"
>
  <!-- header -->
  <app-page-header
    custom-header
    [title]="pageVocabs + 'title'"
    [isForm]="false"
    [loading]="loading"
    [showAuditBtn]="false"
    [showHelpBtn]="true"
    [showAddBtn]="false"
    (onShowHelp)="onShowHelpPage()"
  >
    <div before-btns>
      <button
        type="button"
        class="btn btn-secondary btn-hover-rise txt-lg button-shadow tw-ml-1 tw-flex tw-items-center"
        mat-ripple
        (click)="openPaymentPage()"
      >
        <span class="tw-mx-1">{{ "pages.payments.title" | translate }}</span>
      </button>
    </div>
  </app-page-header>

  <!-- content -->
  <div class="app-page-content">
    <!-- form -->
    <form [formGroup]="form" autocomplete="off">
      <!-- messageSenderInformation -->
      <section>
        <fieldset>
          <!-- TypePayments -->
          <div class="row">
            <!-- Type Payments -->
            <div class="tw-w-full tw-my-2">
              <h4 class="tw-text-xl tw-text-center tw-mb-2">
                {{ fields + "typePayment" | translate }}
              </h4>

              <section class="radio-btns tw-py-2 tw-pb-5 tw-mb-5 border-bottom">
                <!-- OnLine -->
                <div
                  class="radio-btn"
                  (click)="onSelectPaymentType(TypePayments.OnLine)"
                >
                  <input
                    type="radio"
                    id="onlinePayment"
                    name="select"
                    value="1"
                    [checked]="model.typePayment == TypePayments.OnLine"
                  />
                  <label for="onlinePayment">
                    <div class="tw-h-14 tw-mt-2">
                      <span
                        [inlineSVG]="'/assets/media/icons/payment/OnLine.svg'"
                        class="tw-w-16"
                      ></span>
                    </div>
                    <h6 class="payment-type">
                      {{ "enums.TypePayments.OnLine" | translate }}
                    </h6>
                  </label>
                </div>

                <!-- Card -->
                <div
                  class="radio-btn"
                  (click)="onSelectPaymentType(TypePayments.Card)"
                >
                  <input
                    type="radio"
                    id="cardPayment"
                    name="select"
                    value="1"
                    [checked]="model.typePayment == TypePayments.Card"
                  />
                  <label for="cardPayment">
                    <div class="tw-h-14 tw-mt-2">
                      <span
                        [inlineSVG]="'/assets/media/icons/payment/Card.svg'"
                        class="tw-w-16"
                      ></span>
                    </div>
                    <h6 class="payment-type">
                      {{ "enums.TypePayments.Card" | translate }}
                    </h6>
                  </label>
                </div>

                <!-- Account -->
                <div
                  class="radio-btn"
                  (click)="
                    onSelectPaymentType(TypePayments.DepositToTheAccount)
                  "
                >
                  <input
                    type="radio"
                    id="accountPayment"
                    name="select"
                    value="1"
                    [checked]="
                      model.typePayment == TypePayments.DepositToTheAccount
                    "
                  />
                  <label for="accountPayment">
                    <div class="tw-h-14 tw-mt-2">
                      <span
                        [inlineSVG]="'/assets/media/icons/payment/Account.svg'"
                        class="tw-w-16"
                      ></span>
                    </div>
                    <h6 class="payment-type">
                      {{ "enums.TypePayments.Account" | translate }}
                    </h6>
                  </label>
                </div>

                <!-- Cash -->
                <div
                  class="radio-btn"
                  (click)="onSelectPaymentType(TypePayments.Cash)"
                >
                  <input
                    type="radio"
                    id="cashPayment"
                    name="select"
                    value="1"
                    [checked]="model.typePayment == TypePayments.Cash"
                  />
                  <label for="cashPayment">
                    <div class="tw-h-14 tw-mt-2">
                      <span
                        [inlineSVG]="'/assets/media/icons/payment/Cash.svg'"
                        class="tw-w-16"
                      ></span>
                    </div>
                    <h6 class="payment-type">
                      {{ "enums.TypePayments.Cash" | translate }}
                    </h6>
                  </label>
                </div>

                <!-- Cheque -->
                <div
                  class="radio-btn"
                  (click)="onSelectPaymentType(TypePayments.Cheque)"
                >
                  <input
                    type="radio"
                    id="chequePayment"
                    name="select"
                    value="1"
                    [checked]="model.typePayment == TypePayments.Cheque"
                  />
                  <label for="chequePayment">
                    <div class="tw-h-14 tw-mt-2">
                      <span
                        [inlineSVG]="'/assets/media/icons/payment/Cheque.svg'"
                        class="tw-w-16"
                      ></span>
                    </div>
                    <h6 class="payment-type">
                      {{ "enums.TypePayments.Cheque" | translate }}
                    </h6>
                  </label>
                </div>
              </section>
            </div>
          </div>

          <!--OnLine -->
          <div
            class="tw-flex-center tw-flex-col"
            *ngIf="model.typePayment == TypePayments.OnLine"
          >
            <!-- amount -->
            <div class="2xl:tw-w-1/4 xl:tw-w-1/3 md:tw-w-1/2 tw-w-5/6 tw-my-4">
              <form-field
                type="tel"
                [hasNumberSeparator]="true"
                [value]="model.amount"
                (valueChange)="model.amount = $event; numToPersian($event)"
                [hasCurrency]="true"
                [control]="form?.get('amount')"
                label="common.amount"
                [classList]="'tw-text-center tw-text-xl tw-mb-[5px]'"
              >
              </form-field>
              <h6 class="tw-text-center tw-mt-3 text-gray tw-font-normal">
                {{ amountLetters }} {{ "common.toman" | translate }}
              </h6>
            </div>

            <!-- payment-gateway -->
            <div
              class="xl:tw-w-1/2 md:tw-w-3/5 tw-w-5/6 tw-flex-center tw-flex-col tw-my-5 tw-pt-3"
              *ngIf="isShowPaymentGatewaySelector"
            >
              <h6 class="fs-1-2rem tw-font-normal tw-my-24px text-gray">
                {{ pageVocabs + "publicPaymentGateway" | translate }} :
              </h6>
              <div class="rounded bg-light tw-p-5">
                <payment-gateway-selector
                  [tagName]="tagName"
                  type="forIncreaseCredit"
                  (isShowPaymentGatewaySelector)="
                    isShowPaymentGatewaySelector = $event
                  "
                  (itemsCount)="bankOnlineGatewayCount = $event"
                  (selectedItem)="getSelectedBankOnlineGateway($event)"
                >
                </payment-gateway-selector>
              </div>
            </div>
          </div>

          <div
            class="row tw-px-5"
            *ngIf="model.typePayment != TypePayments.OnLine"
          >
            <!-- amount -->
            <div class="sm:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4">
              <form-field
                type="tel"
                [hasNumberSeparator]="true"
                [(value)]="model.amount"
                [hasCurrency]="true"
                [control]="form?.get('amount')"
                label="common.amount"
              >
              </form-field>
            </div>

            <!-- accountInformationId -->
            <div
              class="sm:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4"
              *ngIf="model.typePayment != TypePayments.Cash"
            >
              <account-information-select-search
                *ngIf="
                  model.typePayment == TypePayments.DepositToTheAccount ||
                  model.typePayment == TypePayments.Cheque
                "
                [control]="form?.get('accountInformationId')"
                [(value)]="model.accountInformationId"
                (onError)="onClose()"
              >
              </account-information-select-search>
              <card-number-information-select-search
                *ngIf="model.typePayment == TypePayments.Card"
                [control]="form?.get('accountInformationId')"
                [(value)]="model.accountInformationId"
                (onError)="onClose()"
              >
              </card-number-information-select-search>
            </div>

            <!-- billNumber -->
            <div class="sm:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4">
              <form-field
                [(value)]="model.billNumber"
                [control]="form?.get('billNumber')"
                [label]="fields + 'billNumber'"
                classList="dir-ltr"
              >
              </form-field>
            </div>

            <ng-container *ngIf="model.typePayment == TypePayments.Cheque">
              <!-- branchCode -->
              <div class="sm:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4">
                <form-field
                  [(value)]="model.branchCode"
                  [control]="form?.get('branchCode')"
                  [label]="fields + 'branchCode'"
                  [maxLength]="16"
                  classList="dir-ltr"
                >
                </form-field>
              </div>

              <!-- chequeAccountNumber -->
              <div class="tw-w-full xl:tw-w-2/3 2xl:tw-w-1/2">
                <!-- (keydown)="stopDeleting($event)" -->
                <div class="tw-w-full">
                  <form-field
                    class="tw-w-full"
                    [label]="fields + 'chequeAccountNumber'"
                    [control]="form?.get('chequeAccountNumber')"
                    [(value)]="chequeAccountNumber"
                    type="tel"
                    classList="tw-text-lg dir-ltr"
                    [minLength]="24"
                    [maxLength]="24"
                    [isOnlyNumber]="true"
                  >
                    <span suffix-content class="tw-text-[15px]">IR</span>
                  </form-field>
                </div>
              </div>

              <!-- chequeAmount -->
              <div class="sm:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4">
                <form-field
                  [(value)]="model.chequeAmount"
                  [hasCurrency]="true"
                  [control]="form?.get('chequeAmount')"
                  type="tel"
                  [hasNumberSeparator]="true"
                  [label]="fields + 'chequeAmount'"
                  [min]="1"
                >
                </form-field>
              </div>

              <!-- holderName -->
              <div class="sm:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4">
                <form-field
                  [(value)]="model.holderName"
                  [control]="form?.get('holderName')"
                  [label]="fields + 'holderName'"
                >
                </form-field>
              </div>

              <!-- nationalCode -->
              <div class="sm:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4">
                <form-field
                  [(value)]="model.nationalCode"
                  [control]="form?.get('nationalCode')"
                  [label]="fields + 'nationalCode'"
                  [maxLength]="11"
                  classList="dir-ltr"
                >
                </form-field>
              </div>

              <!-- sayadNumber -->
              <div class="sm:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4">
                <form-field
                  [(value)]="model.sayadNumber"
                  [control]="form?.get('sayadNumber')"
                  [label]="fields + 'sayadNumber'"
                  [maxLength]="20"
                  classList="dir-ltr"
                >
                </form-field>
              </div>

              <!-- serialNumber -->
              <div class="sm:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4">
                <form-field
                  [(value)]="model.serialNumber"
                  [control]="form?.get('serialNumber')"
                  [label]="fields + 'serialNumber'"
                  [maxLength]="10"
                  classList="dir-ltr"
                >
                </form-field>
              </div>

              <!-- seriesNumber -->
              <div class="sm:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4">
                <form-field
                  [(value)]="model.seriesNumber"
                  [control]="form?.get('seriesNumber')"
                  [label]="fields + 'seriesNumber'"
                  [maxLength]="6"
                  classList="dir-ltr"
                >
                </form-field>
              </div>

              <!-- dueDate -->
              <div class="sm:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4">
                <datepicker
                  [value]="dueDate"
                  (value)="dueDate = $event"
                  [control]="form?.get('dueDate')"
                  [label]="fields + 'dueDate'"
                  (onErrorDatePicker)="showErrorDialog($event)"
                >
                </datepicker>
              </div>

              <!-- typeBank -->
              <div class="sm:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4">
                <enum-select-search
                  class="tw-w-full"
                  enumName="TypeBanks"
                  label="common.bank"
                  [control]="form?.get('typeBank')"
                  [(value)]="model.typeBank"
                  (onError)="onClose()"
                >
                </enum-select-search>
              </div>
            </ng-container>

            <!-- *ngIf="model.typePayment!=TypePayments.OnLine" -->

            <!-- paymentDate -->
            <div class="sm:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4">
              <datepicker
                [value]="paymentDate"
                (value)="paymentDate = $event"
                [control]="form?.get('paymentDate')"
                [label]="fields + 'paymentDate'"
                (onErrorDatePicker)="showErrorDialog($event)"
              >
              </datepicker>
            </div>

            <!--expireTime-->
            <div class="sm:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4">
              <timepicker
                [value]="paymentTime"
                (value)="paymentTime = $event"
                [control]="form?.get('paymentTime')"
                [label]="fields + 'paymentTime'"
                [confirmBtnClass]="'btn' | themeColor"
              >
              </timepicker>
            </div>

            <!-- description -->
            <div
              [ngClass]="
                model.typePayment == TypePayments.Cheque ||
                model.typePayment == TypePayments.Cash
                  ? ' xl:tw-w-2/3 2xl:tw-w-1/2'
                  : ' xl:tw-w-1/2 2xl:tw-w-1/4'
              "
            >
              <form-textarea
                class="tw-w-full"
                label="common.description"
                [(value)]="model.description"
                [control]="form?.get('description')"
                [rows]="1"
                maxlength="100"
              >
              </form-textarea>
            </div>

            <!-- chequeImageAddress -->
            <div
              class="md:tw-w-1/2"
              *ngIf="
                model.typePayment == TypePayments.Cheque ||
                model.typePayment == TypePayments.DepositToTheAccount ||
                model.typePayment == TypePayments.Card
              "
            >
              <div class="image-upload">
                <file-uploader
                  #fileUploader
                  [label]="
                    model.typePayment == TypePayments.Cheque
                      ? fields + 'chequeImageAddress'
                      : 'common.paymentImage'
                  "
                  [control]="form?.get('chequeImageAddress')"
                  class="tw-w-[275px]"
                  (valueChange)="getFile($event)"
                  acceptFile=".jpeg,.png,.jpg,.pdf"
                  [maxFileSize]="100"
                  sizeType="kb"
                  (onErrorFile)="showErrorDialog($event)"
                >
                </file-uploader>

                <app-show-images
                  *ngIf="imageUrl"
                  class="tw-mt-1"
                  [src]="imageUrl"
                ></app-show-images>

                <app-pdf-reader
                  *ngIf="pdfUrl"
                  class="tw-mt-1"
                  [src]="pdfUrl"
                ></app-pdf-reader>
              </div>
            </div>
          </div>

          <!-- form btns-->
          <section class="tw-my-15px">
            <div
              class="tw-flex tw-ml-2 tw-my-5"
              [class]="
                model.typePayment == TypePayments.OnLine
                  ? 'tw-justify-center'
                  : 'tw-justify-end'
              "
            >
              <div class="tw-flex tw-justify-end">
                <!-- submit -->
                <button
                  type="button"
                  (click)="onSubmit()"
                  mat-ripple
                  class="btn tw-w-[200px] tw-py-4 tw-mx-[5px] button-shadow"
                  [themeColor]="'btn'"
                  [disabled]="
                    !form.valid ||
                    loading ||
                    (model.typePayment == TypePayments.OnLine &&
                      bankOnlineGatewayCount == 0)
                  "
                >
                  <ng-container *ngIf="!loading">
                    <span> {{ "common.payment" | translate }}</span>
                  </ng-container>

                  <ng-container *ngIf="loading">
                    <span
                      class="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    <span class="sr-only">Loading...</span>
                  </ng-container>
                </button>
              </div>
            </div>
          </section>
        </fieldset>
      </section>
    </form>
  </div>
</app-page-body>

<!-- invoice -->
<app-payment-invoice *ngIf="isVisibleInvoice"></app-payment-invoice>

<!---------------------------------------- help ---------------------------------------->
<ng-container *ngIf="isVisibleHelpPage">
  <app-help-page
    menuTitle="newPayment"
    (hidePage)="onHideHelpPage()"
    title="pages.newPayment.title"
  >
  </app-help-page>
</ng-container>
